import React, { useState } from "react";
import {
  dismissAnalyticsBanner,
  isAnalyticsBannerDismissed,
  isAnalyticsOptedOut,
  setAnalyticsOptOut,
} from "@/lib/analytics";

/**
 * Default-on first-party analytics notice with Opt out / Got it.
 * Opt-out stops client pageviews; signed-in product events may still be recorded server-side.
 */
export default function AnalyticsConsentBanner() {
  const [visible, setVisible] = useState(
    () => !isAnalyticsBannerDismissed() && !isAnalyticsOptedOut()
  );

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[80] border-t border-border bg-card/95 backdrop-blur px-4 py-3 shadow-lg"
      role="region"
      aria-label="Analytics notice"
    >
      <div className="mx-auto flex max-w-3xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground leading-snug">
          We use first-party analytics to understand visits and product use.
          You can opt out of client pageview tracking anytime. When signed in,
          basic product activity may still be recorded for Circa staff ops.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            className="rounded-md border border-border px-3 py-1.5 text-sm text-foreground hover:bg-accent"
            onClick={() => {
              setAnalyticsOptOut(true);
              dismissAnalyticsBanner();
              setVisible(false);
            }}
          >
            Opt out
          </button>
          <button
            type="button"
            className="rounded-md bg-primary px-3 py-1.5 text-sm text-primary-foreground hover:opacity-90"
            onClick={() => {
              dismissAnalyticsBanner();
              setVisible(false);
            }}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
